import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/product-comparison/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import CompareCRM from "../components/product-comparison/CompareCRM";
import WhyChooseUs from "../components/product-comparison/WhyChooseUs";
import Cta from "../components/product-comparison/Cta";
import Testimonials from "../components/product-comparison/Testimonials";

const ProductComparison = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <CompareCRM />
      <WhyChooseUs />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default ProductComparison;
